import {ensureHttpUrl, ensureDoubleSlash} from 'common/util/filterImgUrl'

/**
 * 每次改变链接query (history模式)的时候执行一下函数
 * @param info, {title 分享标题，desc 分享描述, link 分享连接，imgUrl 分享图片链接}
 * 注意 link = location.href.replace(location.hash, '')，砍价插件不需要分享hash
 */
function getNewWxConfigParam (campaignInf, currentPlay) {
  let newWord = {
    title: '',
    desc: '',
    link: '',
    imgUrl: ''
  }
  if (currentPlay) {
    newWord.title = campaignInf
      .share_title
      .replace(/#price/g, (currentPlay.amount_after / 100).toFixed(2))
      .replace(/#name/g, currentPlay.nick_name)
    newWord.desc = campaignInf
      .share_desc
      .replace(/#price/g, (currentPlay.amount_after / 100).toFixed(2))
      .replace(/#name/g, currentPlay.nick_name)
    newWord.link = window.location.href.replace(window.location.hash, '')
    let imgUrl = ensureDoubleSlash(campaignInf.share_image_url)
    imgUrl = ensureHttpUrl(imgUrl)
    newWord.imgUrl = imgUrl
  } else {
    newWord.title = campaignInf
      .share_title
      .replace(/#price/g, (campaignInf.original_price / 100).toFixed(2))
      .replace(/#name/g, '我')
    newWord.desc = campaignInf
      .share_desc
      .replace(/#price/g, (campaignInf.original_price / 100).toFixed(2))
      .replace(/#name/g, '我')
    newWord.link = window.location.href.replace(window.location.hash, '')
    let imgUrl = ensureDoubleSlash(campaignInf.share_image_url)
    imgUrl = ensureHttpUrl(imgUrl)
    newWord.imgUrl = imgUrl
  }
  return newWord
}

function reconfigWx (info) {
  if (window.wx && /micromessenger/i.test(window.navigator.userAgent) && window.yhsdWxShare) {
    window.yhsdWxShare.setInfo(info)
    window.yhsdWxShare.init()
  }
}

/**
 * 图片url过滤
 * @param {String} url
 */
function filterImgUrl (url) {
  if (url.match(/^http/) && url.match(/^http/)['index'] === 0) {
    return url
  }
  if (url.match(/^https/) && url.match(/^https/)['index'] === 0) {
    return url
  }
  if (url.match(/^\/\//) && url.match(/^\/\//)['index'] === 0) {
    return url
  }
  return `//${url}`
}

export {getNewWxConfigParam, reconfigWx}



// WEBPACK FOOTER //
// ./src/common/util/wxUrlConfig.js